import { Component } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { Router } from '@angular/router';
import { FormsModule, UntypedFormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from '../../service/global.service';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxStarsModule } from 'ngx-stars';
import { CustomerDashboardMenuComponent } from '../customer-dashboard-menu/customer-dashboard-menu.component';
import { ViewHoroscopeReportComponent } from '../view-horoscope-report/view-horoscope-report.component';

@Component({
  selector: 'app-customer-horoscope-report-order-history',
  standalone: true,
  imports: [CommonModule,FormsModule,InfiniteScrollModule,NgxStarsModule,CustomerDashboardMenuComponent,ViewHoroscopeReportComponent],
  templateUrl: './customer-horoscope-report-order-history.component.html',
  styleUrl: './customer-horoscope-report-order-history.component.scss'
})
export class CustomerHoroscopeReportOrderHistoryComponent {
  reportData: any;
  reportViewData: any;
  horoscopreReportOrderId: any;

  customerReview: any = '';
  customerRating: any = 0;
  orderData: any = '';
  userData: any;
  customerId:any;

  constructor(private _homeService: HttpService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    // private toastr: ToastrService,
    private hidemodel: NgbModal,
public gS: GlobalService
  ) {

    this.customerId = this.gS.userData?.id;
    if (this.gS.customerId != null) {

    } else {
      this.router.navigate(['/home']);
    }

  }

  ngOnInit(): void {
    this.getReportOrderDetails();
  }


  getReportOrderDetails() {

    this._homeService.getReportOrderDetails(this.customerId, 500).subscribe((data) => {
      let value: any = data;
      this.reportData = value.data;
      console.log(this.reportData, "report");
    }, (error) => {
      console.log(error);
    });

  }


  getReportOrderViewStatus() {
    
    let payload = {
      orderId: this.orderData?.id,
      userId: this.userData?.id
    };

    this._homeService.getChangeReportOrderViewStatus(payload).subscribe({
      next: (res: any) => {
        if (res?.status === "success") {
          this.reportViewData = res?.data;
          console.log(this.reportViewData, 'userviewdata');
        } else {
          console.error('Failed to fetch report view status:', res?.message);
        }
      },
      error: (err) => {
        console.error('Error occurred:', err);
      }
    });
  }



  viewHoroscopreOrder(item: any) {
    this.horoscopreReportOrderId = item?.id
  }

  eventClosePalmOrder(event: any) {
    this.horoscopreReportOrderId = null;
  }


  showMoadl(item: any) {
    this.orderData = item;
    if (this.orderData?.customerReview) {
      this.customerReview = this.orderData?.customerReview;
    }
    // $("#rateReportConsulatation").modal('show');
    console.log(this.orderData, "order");

  }

  closeMoadl() {
    // $("#rateReportConsulatation").modal('hide');
    this.orderData = '';
    this.customerReview = '';
    this.customerRating = 0;
  }

  onRatingSet(event: any) {
    console.log(event);
    this.customerRating = event;
  }

  submitReview() {
    let payload = {
      orderId: this.orderData?.id,
      customerRating: this.customerRating,
      customerReview: this.customerReview,
      path: 'submit-rate-and-review-horoscope-order'
    }
    this._homeService.submitratereview(payload).subscribe((data: any) => {
      if (data?.status == 'success') {
        console.log(data);
        this.closeMoadl();
        this.getReportOrderDetails();
      } else {
        // this.toastr.error(data?.reason, "Error");
      }
    }, (error) => {
      console.log(error);
    });
  }

}
